module.exports = __webpack_public_path__ + "static/media/10@2x.4dd02b3b.png";